<template>
  <div id="news" class="news">
    <div class="zy_constr">
      <div class="news-title">新闻中心</div>
      <div class="news-list">
        <div class="news-item" v-for="item in infoList.list.slice(0, listLength)" :key="item.title">
          <a :href="item.href" target="_blank" class="news-item__title">{{ item.title }}</a>
          <a :href="item.href" target="_blank" class="news-item__date">{{ item.date }} <span v-if="isMobile" class="news-item__detail">查看详情<i class="news-item__detail__icon"></i></span></a>
        </div>
        <div class="news-item">
          <router-link class="news-item__more" to="/allnews">更多动态<i class="news-item__more__icon"></i></router-link>
        </div>
      </div>
      <div class="news-gallery">
        <a
          :href="item.href"
          target="_blank"
          class="news-gallery__item"
          v-for="(item, index) in infoList.list_img"
          :key="index"
        >
          <div class="news-gallery__img">
            <img v-lazy="item.img" alt />
          </div>
          <div class="news-gallery__content">
            <div class="news-gallery__title">{{ item.title }}</div>
            <div class="news-gallery__desc">{{ item.desc }}</div>
            <div class="news-gallery__more">阅读详情<i class="news-gallery__more__icon"></i></div>
          </div>
        </a>
        <!-- 占位符: 解决小米手机谷歌浏览器，小米手机 QQ浏览器,oppo pad自带浏览器  zy_about_advantage_list设置padding-right 后不生效的bug-->
        <div v-if="isMobile" class="news-gallery__item_placeholder"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { isMobile } from '@/utils/utils';
import { Mixins } from '@ireader/core-lib';

const NEWS_LIST_LENGTH_MOBILE = 3;

export default {
  name: 'News',
  mixins: [Mixins.sdd()],
  data() {
    return {
      isMobile: isMobile(),
      infoList: {
        list_img: [],
        list: []
      }
    };
  },
  mounted() {
    this.getNewsList();
    this.$nextTick(() => {
      this.setGalleryHeight();
      window.addEventListener('resize', this.setGalleryHeight);
    });
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.setGalleryHeight);
  },
  computed: {
    listLength() {
      return this.isMobile ? NEWS_LIST_LENGTH_MOBILE : this.infoList.list.length;
    }
  },
  methods: {
    async getNewsList() {
      try {
        const res = await this.$getSdd('zycom/news_ digest');
        this.infoList = res || [];
        this.$nextTick(() => {
          this.setGalleryHeight();
        });
      } catch (err) {
        console.log(err);
      }
    },

    /**
     * 设置新闻图片区域的高度
     * 根据最高的 item 来设置所有 item 的高度
     */
    setGalleryHeight() {
      if (isMobile()) return; // 移动端不需要设置高度
      
      const items = document.querySelectorAll('.news-gallery__item');
      if (!items.length) return;

      // 重置高度以获取真实高度
      items.forEach(item => {
        item.style.height = 'auto';
      });

      // 获取最大高度
      let maxHeight = 0;
      items.forEach(item => {
        const height = item.offsetHeight;
        maxHeight = Math.max(maxHeight, height);
      });

      // 设置所有 item 的高度
      items.forEach(item => {
        item.style.height = `${maxHeight}px`;
      });
    }
  }
};
</script>
<style lang="scss">
@import '@/styles/variables.scss';
@import '@/styles/function.scss';
@import '@/styles/mixin.scss';

.news {
  padding: 60px 0;
}

.news-title {
  font-size: 40px;
  line-height: 60px;
  font-weight: 500;
  color: #000;
  text-align: center;
}

.news-list {
  margin-top: 48px;
  display: flex;
  height: 172px;
  flex-wrap: wrap;
  flex-direction: column;
  position: relative;
  &::after {
    content: '';
    position: absolute;
    width: 1px;
    height: 100%;
    left: 50%;
    top: 0;
    background: rgba(0, 0, 0, 0.05);
  }
}

.news-item {
  width: 50%;
  box-sizing: border-box;
  display: block;
  height: 44px;
  margin-top: 20px;
  &:hover {
    .news-item__title {
      color: #000;
    }
  }

  &:nth-child(3n - 2) {
    margin-top: 0;
  }

  &:nth-child(-n + 3) {
    padding-right: 80px;
  }

  &:nth-child(n + 4) {
    padding-left: 80px;
  }
}

.news-item__title {
  display: block;
  font-size: 16px;
  line-height: 20px;
  color: #000;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.news-item__date {
  display: block;
  font-size: 12px;
  line-height: 16px;
  color: rgba(0, 0, 0, 0.35);
  margin-top: 8px;
}

.news-item__more {
  font-size: 16px;
  color: #1680fc;
  display: flex;
  align-items: center;
  &:hover {
    color: #0f5ab0;
    .news-item__more__icon {
      transform: translateX(6px);
    }
  }
}

.news-item__more__icon {
  display: block;
  width: 16px;
  height: 16px;
  margin-left: 2px;
  position: relative;
  transition: all 0.3s ease;

  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-75%, -50%) rotate(45deg);
    width: 8px;
    height: 8px;
    border-top: 1px solid #1680fc;
    border-right: 1px solid #1680fc;
  }
}

.news-gallery {
  display: flex;
  margin-top: 48px;
}

.news-gallery__item {
  width: 376px;
  margin-left: 16px;
  overflow: hidden;
  border-radius: 16px;
  border: 1px solid rgba(0, 0, 0, 0.05);
  background: #f8f8fa;
  &:first-child {
    margin-left: 0;
  }
  &:hover {
    .news-gallery__img {
      img {
        transform: scale(1.1);
      }
    }
    .news-gallery__more {
      color: #0f5ab0;
      &__icon {
        transform: translateX(6px);
      }
    }
  }
}

.news-gallery__content {
  padding: 12px 16px 16px;
  box-sizing: border-box;
}

.news-gallery__title {
  font-size: 16px;
  line-height: 24px;
  height: 48px;
  color: #000;
  font-weight: 500;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
}

.news-gallery__desc {
  font-size: 14px;
  line-height: 25px;
  height: 75px;
  color: rgba(0, 0, 0, 0.85);
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: 12px;
}

.news-gallery__img {
  width: 100%;
  height: 160px;
  overflow: hidden;
  img {
    display: block;
    width: 100%;
    transition: all 0.3s ease;
  }
}

.news-gallery__more {
  margin-top: 12px;
  font-size: 12px;
  color: #1680fc;
  display: flex;
  align-items: center;

  &__icon {
    width: 10px;
    height: 10px;
    margin-left: 2px;
    position: relative;
    transition: all 0.3s ease;

    &::after {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-75%, -50%) rotate(45deg);
      width: 6px;
      height: 6px;
      border-top: 1px solid #1680fc;
      border-right: 1px solid #1680fc;
    }
  }
}
.S {
  .news {
    padding: rem(72) 0 rem(108);
  }
  .news-title {
    font-size: rem(60);
    line-height: rem(72);
  }
  .news-list {
    margin-top: rem(36);
    padding: 0 rem(48);
    height: auto;
    &::after {
      display: none;
    }
  }
  .news-item {
    width: 100%;
    height: auto;
    margin-top: rem(36);
    &:nth-child(-n + 3) {
      padding-right: 0;
    }

    &:nth-child(n + 4) {
      padding-left: 0;
    }
  }
  .news-item__title {
    font-size: rem(42);
    line-height: rem(66);
    line-clamp: 2;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    white-space: normal;

  }
  .news-item__date {
    font-size: rem(36);
    line-height: rem(48);
    margin-top: rem(24);
  }
  .news-item__detail {
    font-size: rem(36);
    line-height: rem(48);
    margin-left: rem(12);
    .news-item__detail__icon {
      width: rem(36);
      height: rem(36);
      margin-left: rem(6);
      position: relative;
      &::after {
        content: "";
        position: absolute;
        border-top: 1px solid rgba(0, 0, 0, 0.35);
        border-right: 1px solid rgba(0, 0, 0, 0.35);
        top: 50%;
        right: rem(-36);
        transform: translate(-50%, -50%) rotate(45deg);
        width: rem(18);
        height: rem(18);
      }
    }
  }
  .news-item__more {
    font-size: rem(42);
    &:hover {
      color: #1680fc;
      .news-item__more__icon {
        transform: translateX(0);
      }
    }
  }
  .news-item__more__icon {
    width: rem(36);
    height: rem(36);
    margin-left: rem(6);
    &::after {
      width: rem(18);
      height: rem(18);
    }
  }
  .news-gallery {
    margin-top: rem(72);
    padding-left: rem(48);
    overflow-x: auto;
     /* 隐藏滚动条 */
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE and Edge */
    &::-webkit-scrollbar {
      display: none; /* Chrome, Safari and Opera */
    }
  }
  .news-gallery__item {
    position: relative;
    flex-shrink: 0;
    width: rem(720);
    margin-left: rem(24);
    &:first-child {
      margin-left: 0;
    }
    &:hover {
      .news-gallery__img {
        img {
          transform: none;
        }
      }
      .news-gallery__more {
        color: #1680fc;
        &__icon {
          transform: none;
        }
      }
    }
  }
  .news-gallery__item_placeholder {
    flex-shrink: 0;
    width: rem(48);
  }
  .news-gallery__img {
    height: rem(306);
    position: relative;
    &::after {
      content: '';
      position: absolute;
      bottom: rem(-3);
      left: 0;
      width: 100%;
      height: rem(144);
      background: rgba(0, 0, 0, 0.5);
      background: linear-gradient(180deg, rgba(248, 248, 250, 0) 0%, #f8f8fa 100%);
    }
    img {
      width: 101%;
      object-fit: cover;
    }
  }
  .news-gallery__content {
    padding: rem(24) rem(42) rem(96);
  }
  .news-gallery__title {
    font-size: rem(42);
    line-height: rem(66);
    height: auto;
  }
  .news-gallery__desc {
    font-size: rem(36);
    line-height: rem(54);
    height: auto;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
    overflow: hidden;
    text-overflow: ellipsis;
    margin: rem(24) 0 rem(18);

  }
  .news-gallery__more {
    font-size: rem(36);
    line-height: rem(48);
    margin-top: 0;
    position: absolute;
    bottom: rem(36);
    left: rem(42);
    &:hover {
      color: #1680fc;
      .news-item__more__icon {
        transform: none;
      }
    }
    &__icon {
      width: rem(36);
      height: rem(36);
      margin-left: rem(6);
      &::after {
        width: rem(18);
        height: rem(18);
      }
    }
  }
}
/* Android 特定样式 */
@supports not (-webkit-touch-callout: none) {
    .S .news-title {
      font-weight: bold;
    }
}
</style>
